// angular
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-toggle-switch',
  standalone: true,
  imports: [NgOptimizedImage, TranslateModule, CommonModule],
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.scss',
})
export class ToggleSwitchComponent implements OnInit {
  public value: boolean | null = null;
  public disabled = false;
  public checked = false;

  // inputs
  label = input<string>('');
  labelClasses = input<string>();
  labelIcon = input<string>();
  labelIconClasses = input<string>();
  isDisabled = input<boolean>(false);
  isChecked = input<boolean>(false);

  // outputs
  onToggle = output<boolean>();

  writeValue(value: boolean) {
    this.value = value;
    this.onToggle.emit(value);
  }

  ngOnInit(): void {
    this.isDisabled() && this.setDisabledState(this.isDisabled());
    this.isChecked() && this.setCheckedState(this.isChecked());
  }

  /* eslint-disable-next-line @typescript-eslint/no-empty-function */
  onChange() {}

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  /* eslint-disable-next-line @typescript-eslint/no-empty-function */
  onTouched() {}

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  // set disable mode
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // set check or uncheck mode
  setCheckedState(isChecked: boolean): void {
    this.writeValue(isChecked);
    this.checked = isChecked;
  }
}
